import React from 'react';
import MdeEDitorContain from '../../Componant/Editor/MDEEditor/MDEEditor';

const MdeEDitor = () => {
  return (
    <div className='page-body'>
      <MdeEDitorContain />
    </div>
  );
};

export default MdeEDitor;
